import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import DepartmentsTable from '../../components/departments/DepartmentsTable';

const Departments = () => (
    <WrapperSection>
        <GlobalBreadcrumbs />
        <DepartmentsTable />
    </WrapperSection>
);

export default Departments;
